import { appApiSlice } from './app-ApiSlice';
import { getFrontendURL } from 'src/utils/url';

export interface ProductFruitsConfig {
  workspaceCode: string;
  language: string;
  username: string;
  email: string;
  firstname: string;
  lastname: string;
  signUpAt: string;
}

export interface AuthToken {
  token: string;
  yiiEnv: string;
  isLocal: boolean;
  productFruits: ProductFruitsConfig | null;
}

export const authTokenApiSlice = appApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAuthKey: builder.query<AuthToken, number | void>({
      query: () => ({
        url: `${getFrontendURL()}/site/get-auth-token`,
        method: 'GET',
        credentials: 'include',
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetAuthKeyQuery } = authTokenApiSlice;
